import React from "react";
import VerticalTabs from "../../../shared/ReusableComponents/VerticalTabs";
import { AdminFluidOrder } from "./AdminFluidOrder";

export const AdminFluidOrderNav = ({ templateId }: { templateId: any }) => {
  const GetTabs = () => [
    {
      Text: "Adult Fluid Order",
      Component: <AdminFluidOrder templateId={templateId} />,
    },
  ];
  return <VerticalTabs GetTabs={GetTabs} />;
};
